import isAdmin from './isAdmin';
import isOwner from './isOwner';
import isProgramManager from './isProgramManager';
import isProgramTrainer from './isProgramTrainer';
import isTeacher from './isTeacher';

export default function roleShouldStartInTurbineAdmin(role = []) {
  return (
    isTeacher(role) ||
    isProgramTrainer(role) ||
    isProgramManager(role) ||
    isAdmin(role) ||
    isOwner(role)
  );
}
